module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av717-8d3f16df1f4deee9141078bab2009ae6.jpg";